import React from "react";

import PageContent from "2g-page-content";

import RezervaceWidgetNejblizsi from "b2b/components/rezervace-widget/RezervaceWidgetNejblizsi";

import useMessages from "./i18n/useMessages";

function RezervaceCasovyPlan() {
  const { casovyPlanPageHeading } = useMessages();

  return (
    <PageContent>
      <RezervaceWidgetNejblizsi title={casovyPlanPageHeading()} />
    </PageContent>
  );
}

export default React.memo(RezervaceCasovyPlan);
